import { ɵConsole } from '@angular/core';
import { AngularDelegate } from '@ionic/angular';
import { html2json } from 'html2json';
import * as moment from 'moment';

/*{
  nome: 'Internação de Emergência',
  tipo: 'SUMÁRIO DE ALTA',
  data: '09/Dez - 12:00 Horas',
  profissional: 'Dra Mariana da Silva',
  estabelecimento: 'Unidade de Pronto Atendimento de Samambaia',
},*/

export class DocumentReference {
  id?: string;
  nome?: string;
  tipo?: string;
  result?: string;
  fab: any;
  inst?: string;
  type?: string;
  data?: string;
  estabelecimento?: string;
  profissional?: string;
  organization?: string;
  organizationRef?: string;
  practicioner?: string;
  practicionerRole?: string;
  practicionerRoleRef?: string;
  list: any;
  definition: any;
  period: any;
  detail?: any[];
  originCode?: string;
  categoria: any;
  fullpath: any;

  constructor(data?, organization?, practicionerRole?, type?, categoria?, fullpath?) {
    if (data) {
      if (fullpath) {
        this.fullpath = fullpath
      }
      this.id = data.id;
      this.nome = data.title;
      this.data = data.date;
      this.definition = data.definition;
      this.fab = data.fab;
      this.originCode = data.originCode;
      this.inst = data.inst;
      this.result = data.result;
      this.practicionerRoleRef = practicionerRole;
      this.organizationRef = organization;
      this.categoria = categoria;
      if (type) {
        this.type = type;
      } else {
        this.type = data.type.coding[0].code;
      }
      if (data.text) {
        this.list = this.getList(html2json(data.text.div));
        this.period = this.getPeriod(this.list);
      }
      if (this.type.toLowerCase().includes('sumario')) {
        this.tipo = 'SUMÁRIO DE ALTA';
      } if (this.type.includes('CMD')) {
        this.tipo = 'SUMÁRIO DE ALTA';
      } else if (this.type.toLowerCase().includes('atendimento')) {
        this.tipo = 'ATENDIMENTO CLÍNICO';
      } else if (this.type.toLowerCase().includes('imuno')) {
        this.tipo = 'REGISTROS DE VACINA';
      } else if (this.type.toLowerCase().includes('prescricoes')) {
        this.tipo = 'PRESCRICOES';
      } else if (this.type.toLowerCase().includes('medicamento')) {
        this.tipo = 'MEDICAMENTOS';
      } else {
        this.tipo = 'RESULTADO DE EXAMES';
      }
    }
  }


  getList(htmlParse) {
    var result = {}
    if (htmlParse && htmlParse.child) {
      htmlParse.child.forEach((data) => {
        if (data && data.child) {
          data.child.forEach((element) => {
            if (element.attr && element.attr.id && element.child) {
              result[element.attr.id] = element.child[0].text ? element.child[0].text.replace('[GMT]', '') : '';
            }
          })
        }
      })
    }
    return result;
  }

  getPeriod(list) {
    if (list.dtStart && list.dtEnd) {
      let days = moment(list.dtEnd).diff(moment(list.dtStart), "days");
      if (days <= 1) {
        return days + ' dia';
      } else {
        return days + ' dias';
      }
    }
  }

  public static fromDTO?(data) {
    const pacient = new DocumentReference();
    return pacient;
  }

  calcAge(dateString): string {
    const birthday = +new Date(dateString);
    // tslint:disable-next-line: no-bitwise
    const date = ~~((Date.now() - birthday) / (31557600000));
    return date.toString();
  }

  public toDTO?() {
    const dto: any = {};

    return dto;
  }

}
